import React, { useCallback } from 'react'
import { SaleCenterAttachmentsListItem } from './SaleCenterAttachmentsListItem'
import Box from '@mui/material/Box'
import { Scrollbar } from '@workwave-tidal/core/components'
import {
  IAttachmentDTO,
  IAttachmentToAgreementDTO,
  selectAllAttachments,
} from '@user/store/attachments'
import { useSelector } from 'react-redux'
import {
  setSelectedAttachments,
  useSelectedAttachmentStore,
} from '../selectedAttachmentStore'

type Props = {
  canUpdate: boolean
}

export function SaleCenterAttachmentsList({ canUpdate }: Props) {
  const { selectedAttachments, isSelectionEnable } =
    useSelectedAttachmentStore()
  const attachments = useSelector(selectAllAttachments)

  const handleCheckChange = useCallback(
    (attachment: IAttachmentDTO) => {
      const tempSelectedAttachments = [...selectedAttachments]
      const existIndex = tempSelectedAttachments?.findIndex(
        (row) => row?.id == attachment.id,
      )
      const mappedAttachment: IAttachmentToAgreementDTO = {
        attachmentType: attachment.attachmentType,
        createdDate: attachment.createdDate,
        displayName: attachment.displayName,
        fileSize: attachment.fileSize,
        id: attachment.id,
        isSaleCenterAttachment: true,
        isCompletedFormPdf: attachment.isCompletedFormPdf,
      }
      if (existIndex == -1) {
        tempSelectedAttachments.push(mappedAttachment)
        setSelectedAttachments(tempSelectedAttachments)
        return
      }
      tempSelectedAttachments.splice(existIndex, 1)
      setSelectedAttachments(tempSelectedAttachments)
    },
    [selectedAttachments],
  )

  return (
    <Box
      sx={{
        height: isSelectionEnable
          ? 'calc(100vh - 290px)'
          : 'calc(100vh - 255px)',
      }}
    >
      <Scrollbar>
        <Box px={2}>
          {attachments
            ?.sort(
              (a, b) =>
                new Date(b.createdDate).getTime() -
                new Date(a.createdDate).getTime(),
            )
            .map((attachment) => {
              const selected = selectedAttachments?.find(
                (row) => row?.id == attachment.id,
              )
              return (
                <SaleCenterAttachmentsListItem
                  key={attachment.id}
                  attachment={attachment}
                  canUpdate={canUpdate}
                  isSelectionEnable={isSelectionEnable}
                  checked={!!selected}
                  handleCheckChange={() => handleCheckChange(attachment)}
                />
              )
            })}
        </Box>
      </Scrollbar>
    </Box>
  )
}
